import { IOrganization } from 'src/types/organization';
import { endpoints, fetcher, axiosInstance } from 'src/utils/axios';
import useSWR, { SWRResponse } from 'swr';

type UseGetBioPageResponse = SWRResponse<IOrganization, any>;

export function useGetBioPage(normalizedName: string): UseGetBioPageResponse {
  return useSWR<IOrganization>(endpoints.organization.getPage(normalizedName), fetcher, {
    keepPreviousData: true,
  });
}

type UseFindUserExistResponse = SWRResponse<boolean, any>;

export function useFindUserExist(email: string): UseFindUserExistResponse {
  const URL = email ? [endpoints.user.exists, { params: { email } }] : null;

  return useSWR<boolean>(URL, fetcher, {
    keepPreviousData: false,
  });
}

export const fetchUserExists = async (email: string): Promise<boolean> => {
  const response = await axiosInstance.get(endpoints.user.exists, {
    params: { email },
  });
  return response.data;
};
